import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface LoadingScreenProps {
  ready: boolean;
}

const LoadingScreen = ({ ready }: LoadingScreenProps) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (ready) {
      // Allow fade-out animation to complete before unmounting
      const timer = setTimeout(() => setVisible(false), 200);
      return () => clearTimeout(timer);
    }
  }, [ready]);

  useEffect(() => {
    if (!ready) {
      document.body.style.overflow = "hidden";
    } else {
      // Re-enable scroll slightly before fade completes for seamless feel
      const timer = setTimeout(() => {
        document.body.style.overflow = "";
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [ready]);

  if (!visible) return null;

  return (
    <AnimatePresence>
      {!ready &&
      <motion.div
        key="loader"
        className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background"
        exit={{ opacity: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}>
        
          {/* Logo */}
          <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col items-center gap-6">
          
            <img
            src="/favicon.png"
            alt="Zephr Studio"
            className="w-14 h-14"
            draggable={false} />
          
             <span className="font-display text-lg tracking-[0.2em] uppercase text-foreground/80">
               ZEPHR
             </span>
            <span className="font-display text-[8px] tracking-[0.35em] uppercase text-foreground/40 -mt-1">
              STUDIO
            </span>
          </motion.div>

          {/* Loading bar */}
          <motion.div
          className="mt-10 w-48 h-[2px] rounded-full bg-border overflow-hidden"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.4 }}>
          
            <motion.div
            className="h-full bg-primary rounded-full"
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{ duration: 0.6, ease: "easeInOut" }} />
          
          </motion.div>
        </motion.div>
      }
    </AnimatePresence>);

};

export default LoadingScreen;